import { render, staticRenderFns } from "./SectionGalleries.vue?vue&type=template&id=a549580a&scoped=true&"
import script from "./SectionGalleries.vue?vue&type=script&lang=js&"
export * from "./SectionGalleries.vue?vue&type=script&lang=js&"
import style0 from "./SectionGalleries.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SectionGalleries.vue?vue&type=style&index=1&id=a549580a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a549580a",
  null
  
)

export default component.exports